import { put, call } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    getRoleSuccess, getRoleFail,
    getAllRolesSuccess, getAllRolesFail,
    getActiveRolesSuccess, getActiveRolesFail,
    getRolesByModuleSuccess, getRolesByModuleFail,
    getGlobalRolesSuccess, getGlobalRolesFail,
    createRoleSuccess, createRoleFail,
    updateRoleSuccess, updateRoleFail,
    deleteRoleSuccess, deleteRoleFail,
    setRoleLoading
} from "../actions/roleActions";
import {
    API_BASE_URL,
    getRequest,
    putRequest,
    deleteRequest,
    postRequest
} from "../../../api";

export function* getRoleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/${action.payload.roleId}`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 GET_ROLE_REQUEST');
        console.log('📊 Role ID:', action.payload.roleId);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ROLE_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getRoleSuccess(resp.data));
        yield put(setRoleLoading(false));

    } catch (error) {
        console.group('❌ GET_ROLE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getRoleFail(error.message));
        yield put(setRoleLoading(false));
    }
}

export function* getAllRolesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 GET_ALL_ROLES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ALL_ROLES_SUCCESS');
        console.log('📥 Nombre de rôles:', resp.data.length);
        console.groupEnd();

        yield put(getAllRolesSuccess(resp.data));
        yield put(setRoleLoading(false));

    } catch (error) {
        console.group('❌ GET_ALL_ROLES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllRolesFail(error.message));
        yield put(setRoleLoading(false));
    }
}

export function* getActiveRolesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/active`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 GET_ACTIVE_ROLES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ACTIVE_ROLES_SUCCESS');
        console.log('📥 Nombre de rôles actifs:', resp.data.length);
        console.groupEnd();

        yield put(getActiveRolesSuccess(resp.data));
        yield put(setRoleLoading(false));

    } catch (error) {
        console.group('❌ GET_ACTIVE_ROLES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getActiveRolesFail(error.message));
        yield put(setRoleLoading(false));
    }
}

export function* getRolesByModuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/module/${action.payload.moduleId}`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 GET_ROLES_BY_MODULE_REQUEST');
        console.log('📊 Module ID:', action.payload.moduleId);
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_ROLES_BY_MODULE_SUCCESS');
        console.log('📥 Nombre de rôles:', resp.data.length);
        console.groupEnd();

        yield put(getRolesByModuleSuccess(resp.data));
        yield put(setRoleLoading(false));

    } catch (error) {
        console.group('❌ GET_ROLES_BY_MODULE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getRolesByModuleFail(error.message));
        yield put(setRoleLoading(false));
    }
}

export function* getGlobalRolesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/global`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 GET_GLOBAL_ROLES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url, token });

        console.group('✅ GET_GLOBAL_ROLES_SUCCESS');
        console.log('📥 Nombre de rôles globaux:', resp.data.length);
        console.groupEnd();

        yield put(getGlobalRolesSuccess(resp.data));
        yield put(setRoleLoading(false));

    } catch (error) {
        console.group('❌ GET_GLOBAL_ROLES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getGlobalRolesFail(error.message));
        yield put(setRoleLoading(false));
    }
}

export function* createRoleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles`;
    const data = action.payload;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 CREATE_ROLE_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group('✅ CREATE_ROLE_SUCCESS');
        console.log('📥 Rôle créé:', resp.data);
        console.groupEnd();

        yield put(createRoleSuccess(resp.data));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Rôle créé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ CREATE_ROLE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(createRoleFail(error.message));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la création",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* updateRoleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/${action.payload.roleId}`;
    const data = action.payload.roleData;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 UPDATE_ROLE_REQUEST');
        console.log('📊 Role ID:', action.payload.roleId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token });

        console.group('✅ UPDATE_ROLE_SUCCESS');
        console.log('📥 Rôle mis à jour:', resp.data);
        console.groupEnd();

        yield put(updateRoleSuccess(resp.data));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Rôle mis à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ UPDATE_ROLE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateRoleFail(error.message));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la mise à jour",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* deleteRoleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/roles/${action.payload.roleId}`;
    yield put(setRoleLoading(true));

    try {
        console.group('🔵 DELETE_ROLE_REQUEST');
        console.log('📊 Role ID:', action.payload.roleId);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group('✅ DELETE_ROLE_SUCCESS');
        console.log('🗑️ Rôle supprimé');
        console.groupEnd();

        yield put(deleteRoleSuccess(action.payload.roleId));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: "Rôle supprimé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ DELETE_ROLE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(deleteRoleFail(error.message));
        yield put(setRoleLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur de suppression',
            text: error.message,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    }
}